import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fileUploadsData: [],
};

export const fileUploadsSlice = createSlice({
  name: "fileUploads",
  initialState,
  reducers: {
    setFileUploadsData: (state, action) => {
      state.fileUploadsData = action.payload;
    },
    resetFileUploads: () => initialState, // Reset just this slice
  },
});

export const { setFileUploadsData, resetFileUploads } =
  fileUploadsSlice.actions;

const fileUploadsReducer = fileUploadsSlice.reducer;

export default fileUploadsReducer;
